import { Component, Inject } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { CourseManagmentService } from 'src/app/services/course-managment.service';
import { CourseViewModel } from 'src/app/shared/viewModels/course.viewModel';
import { AddCourseComponent } from '../add-course.component';
import { CustomCalendarHeader } from './custom-calendar-header';
import { catchError, throwError } from 'rxjs';
import { HttpResponse } from '@angular/common/http';
import { ToasterService } from 'src/app/services/toaster.service';
import { TOASTER_TYPE } from 'src/app/shared/ui-kit/webiat-toaster/webiat-toaster.viewModel';

@Component({
  selector: 'app-add-course-timing',
  templateUrl: './add-course-timing.component.html',
  styleUrl: './add-course-timing.component.scss'
})
export class AddCourseTimingComponent {
  courseTypeImg!: string;
  courseTimingForm: FormGroup;
  courseData!: CourseViewModel;
  selectedCourse: any = '';
  loading = false;
  monthStartAt: Date|null = null
  CustomCalendarHeader = CustomCalendarHeader;
  constructor(
    private fb: FormBuilder, public dialogRef: MatDialogRef<AddCourseTimingComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any, private courseManagmentService: CourseManagmentService,
    public dialog: MatDialog, private toasterService: ToasterService,
  ) {
    this.courseTimingForm = this.fb.group({
      courseDates: [[], Validators.required],
      startTime: [null, Validators.required],
      endTime: [null, Validators.required]
    });
  }

  dateClass = (date: Date | null): string => {
    if (!date) return '';
    const day = date.getDay();
    const courseDates = this.courseTimingForm.get('courseDates')?.value || [];
    if (day === 0 || day === 6) {
      return 'disabled-date';
    }
    if (courseDates.find((d: Date) => new Date(d).toDateString() === date.toDateString())) {
      return 'selected-date';
    }
    return '';
  };

  ngOnInit(): void {
    this.courseData = this.courseManagmentService.getCourseData();
    if (this.data.courseId) 
      {this.monthStartAt = Array.isArray(this.courseData.courseDates)? null : new Date(this.courseData.courseDates) }
    this.patchForm();
    this.selectedCourse = this.data.clubsList.find((course: any) => course.id === this.courseData.courseType);

    this.loadCourseImage(this.selectedCourse.path);
  }

  public castFormControl(controlName: string): FormControl {
    return this.courseTimingForm.get(controlName) as FormControl;
  }

  patchForm() {
    if (this.courseData) {
      this.courseTimingForm.patchValue({
        courseDates:Array.isArray(this.courseData.courseDates)
        ? this.courseData.courseDates.map(date => new Date(date)):[new Date(this.courseData.courseDates)],
        startTime: this.courseData.startTime,
        endTime: this.courseData.endTime
      });
    }
  }

  loadCourseImage(selectedCoursePath: string): void {

    if (selectedCoursePath) {
      this.courseManagmentService.getCourseCreationImageByPath(selectedCoursePath)
        .subscribe({
          next: (blob) => {
            this.courseTypeImg = URL.createObjectURL(blob);
          },
          error: () => {
            this.courseTypeImg = '';
          },
        });
    }
  }

  onDateSelected(date: Date | null, calendar: any): void {
    if (date === null) {
      return;
    }
  
    // Restrict selection on weekends
    if (date.getDay() === 0 || date.getDay() === 6) {
      return;
    }
  
    if (this.data.courseId) {
      this.courseTimingForm.get('courseDates')?.setValue([date]);
    } else {
      const courseDates = this.courseTimingForm.get('courseDates')?.value || [];
      const index = courseDates.findIndex(
        (d: Date) => new Date(d).toDateString() === date.toDateString()
      );
  
      if (index === -1) {
        courseDates.push(date);
      } else {
        courseDates.splice(index, 1);
      }
  
      this.courseTimingForm.get('courseDates')?.setValue(courseDates);
    }
  
    this.courseTimingForm.get('courseDates')?.markAsDirty();
    calendar.updateTodaysDate();
  }  


  goToPrevModal() {
    this.dialogRef.close();
    const dialogData = this.data.courseId ? 
    { clubsList: this.data.clubsList, courseId: this.data.courseId } : { clubsList: this.data.clubsList };
    this.dialog.open(AddCourseComponent, { data : dialogData});
  }

  updateData() {
    const updatedCourseData = {
      courseDates: this.courseTimingForm.value.courseDates.map((date: string) =>
        this.formatDate(date)
      ),
      startTime: this.formatTime(this.courseTimingForm.value.startTime),
      endTime: this.formatTime(this.courseTimingForm.value.endTime),
    };

    const currentCourseData = this.courseManagmentService.getCourseData();
    const mergedCourseData = {
      ...currentCourseData,
      ...updatedCourseData,
    };

    this.courseManagmentService.updateCourseData(mergedCourseData);

    if (this.courseTimingForm.valid) {
      this.loading = true
      if (this.data.courseId){
        this.modifyCourse(this.data.courseId)
      }else this.createCourse();
    }
    
    this.closeCourseCreation()
  }

  closeCourseCreation() {
    this.dialogRef.close();
  }

  createCourse(){
    this.courseManagmentService.createCourse()
    .pipe(
      catchError((error) => {
        this.loading = false;
        this.toasterService.addToaster(
          true,
          TOASTER_TYPE.ERROR,
          'Échec de publication. Veuillez réessayer',
          5000
        );
        return throwError(() => error);
      })
    )
    .subscribe(
      (res: HttpResponse<any>) => {
        if (res?.ok) {
          this.loading = false;
          this.courseManagmentService.newCourseCreated = true;
          this.toasterService.addToaster(
            true,
            TOASTER_TYPE.SUCCESS,
            'Le cours a été ajouté avec succès',
            5000
          );
        }
      }
    )
  }

  modifyCourse(courseId: string){
    this.courseManagmentService.modifyCourse(courseId)
    .pipe(
      catchError((error) => {
        this.loading = false;
        this.toasterService.addToaster(
          true,
          TOASTER_TYPE.ERROR,
          'Échec de la modification. Veuillez réessayer.',
          5000
        );
        return throwError(() => error);
      })
    )
    .subscribe(
      (res: HttpResponse<any>) => {
        if (res?.ok) {
          this.loading = false;
          this.courseManagmentService.newCourseCreated = true;
          this.toasterService.addToaster(
            true,
            TOASTER_TYPE.SUCCESS,
            'Modification effectuée avec succès !',
            5000
          );
        }
      }
    )
  }

  private formatDate(date: string): string {
    const parsedDate = new Date(date);
    const year = parsedDate.getFullYear();
    const month = String(parsedDate.getMonth() + 1).padStart(2, '0');
    const day = String(parsedDate.getDate()).padStart(2, '0');

    return `${year}-${month}-${day}`;
  }

  private formatTime(time: string): string {
    const [hours, minutes] = time.split(':');
    return `${hours}:${minutes}:00`;
  }

}
